export default __webpack_public_path__ + "media/images/ideal-7b823bb2a9422de432c842089d9c4080.gif";